import * as React from "react";
const SvgCheckIndeterminateSmall = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M240-440v-80h480v80H240Z" }));
export default SvgCheckIndeterminateSmall;
